/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileNumbers32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill="#00A650"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.white}
                d="M21.744 23.524c.141 0 .256.093.256.206v.064c0 .114-.115.206-.256.206H9.256C9.115 24 9 23.908 9 23.794v-.064c0-.113.115-.206.256-.206h12.488zm-6.606-5.203c.062 0 .113.05.113.11V22.9c0 .06-.05.11-.113.11h-2.627a.112.112 0 01-.112-.11v-4.47c0-.06.05-.11.112-.11h2.627zm-3.275 2.66c.046 0 .084.035.084.077v1.876c0 .042-.038.076-.084.076H9.18c-.046 0-.084-.034-.084-.076v-1.876c0-.042.038-.076.084-.076h2.684zM18.458 13c.062 0 .112.05.112.11v9.79a.11.11 0 01-.033.078.113.113 0 01-.08.033H15.83a.111.111 0 01-.112-.111v-9.79a.11.11 0 01.033-.079.113.113 0 01.08-.032h2.627zm3.33 2.93c.056 0 .101.046.101.103v6.873a.102.102 0 01-.1.104h-2.65a.102.102 0 01-.101-.104v-6.873c0-.057.045-.104.1-.104h2.65z"
            />
        </g>
    </AccessibleSVG>
);

export default FileNumbers32;
